define([
	"dojo/_base/declare",
	"csi/heading/Boolean"
], function(declare,BooleanRen) {

	return declare(BooleanRen, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: render checkbox whether context exists or not
			return this.inherited(arguments) || false;
		}
	});
});